import { getInstance as getBootstrap } from 'utils/bootstrap';
import get from 'lodash/get';

export const METHOD_POST = { method: 'POST' };
export const METHOD_DELETE = { method: 'DELETE' };
export const DATA_TYPE_JSON = { dataType: 'json' };
export const CONTENT_TYPE_FORM = {
    'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
};
export const XML_HTTP_REQUEST_HEADER = { 'X-Requested-With': 'XMLHttpRequest' };
export const ACCEPT_JSON_HEADER = { Accept: 'application/json' };

export const parseBodyJson = (response) => response.json();

export const catchSplajaxError = (response) =>
    parseBodyJson(response).then((results) => {
        throw results;
    });

export const safeJsonParse = (rawResponse) => {
    try {
        return JSON.parse(rawResponse);
    } catch (err) {
        return undefined;
    }
};

export const checkResponseCode = (response) => {
    if (!response.ok || response.error || response.status === 'error') {
        throw response;
    }
    return response;
};

export const getEventIdFromBootstrapData = () => {
    const bootstrap = getBootstrap();
    return bootstrap.get('eventId');
};

export const getCsrfTokenFromBootstrapData = () => {
    const bootstrap = getBootstrap();
    return bootstrap.get('csrfToken');
};

export const getEventId = () => get(window, 'splash.server.constants.event_id') || getEventIdFromBootstrapData();

export const getCsrfToken = () =>
    window.splash && window.splash.server && window.splash.server._user
        ? window.splash.server._user.userFormSubmitToken
        : getCsrfTokenFromBootstrapData();

export const getUserFormSubmitTokenHeader = (csrfToken) => ({
    'X-UserFormSubmitToken': csrfToken || getCsrfToken(),
});

/**
 * Return a fully qualified URL if rootDomain is present, otherwise return a relative path
 *
 * @param {string} rootDomain
 * @param {string} csrfToken
 * @param {string} path
 */
export const buildRequestUrl = (rootDomain, csrfToken, path) =>
    rootDomain ? `https://${rootDomain}${path}${path.indexOf('?') !== -1 ? '&' : '?'}csrfToken=${csrfToken}` : path;

export const buildRequestUrlWithoutCsrfToken = (rootDomain, path) =>
    rootDomain ? `https://${rootDomain}${path}` : path;

export const buildRequestUrlWithQueries = ({ rootDomain, csrfToken, path, queryParams = {} }) => {
    const params = [];

    if (csrfToken) {
        params.push(`csrfToken=${csrfToken}`);
    }

    Object.keys(queryParams).forEach((key) => {
        params.push(`${key}=${queryParams[key]}`);
    });

    let baseUrl = `https://${rootDomain}${path}`;
    if (params.length) {
        baseUrl += `?${params.join('&')}`;
    }

    return baseUrl;
};
